import { Box, Dialog, DialogContent, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

import { useSessionOrderEventCleanup } from 'store/trips/use-session-order-event-cleanup'

import {
  CreateTripProvider,
  type TripFormMode,
} from './create-trip-context'
import CreateTripContent from './create-trip-content'

type CreateTripDialogProps = {
  open: boolean
  onClose: () => void
  mode?: TripFormMode
  editingTripId?: number
  onSaved?: () => void
}

const CreateTripDialog = ({
  open,
  onClose,
  mode = 'create',
  editingTripId,
  onSaved,
}: CreateTripDialogProps) => {
  const { cancelTripCreation } = useSessionOrderEventCleanup()

  const handleExit = async () => {
    try {
      await cancelTripCreation()
    } finally {
      onClose()
    }
  }

  return (
    <Dialog
        open={open}
        onClose={handleExit}
        maxWidth={false}
        fullWidth
        PaperProps={{
          sx: {
            width: { xs: '100%', sm: '95vw' },
            maxWidth: 1400,
            height: { xs: '100%', sm: '90vh' },
            maxHeight: 900,
            m: { xs: 0, sm: 2 },
            borderRadius: { xs: 0, sm: 2 },
            overflow: 'hidden',
          },
        }}
      >
        <DialogContent
          sx={{
            p: 0,
            height: '100%',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              flexShrink: 0,
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              px: 1,
              py: 0.5,
              minHeight: 48,
            }}
          >
            <IconButton
              aria-label="close create trip"
              onClick={handleExit}
              disableRipple
              sx={{
                color: 'error.main',
                width: 40,
                height: 40,
                '&:hover': { backgroundColor: 'transparent' },
                '&:active': { backgroundColor: 'transparent' },
                '& .MuiTouchRipple-root': { display: 'none' },
              }}
            >
              <CloseIcon sx={{ fontSize: 40 }} />
            </IconButton>
          </Box>
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <CreateTripProvider
              onExit={handleExit}
              mode={mode}
              editingTripId={editingTripId}
              onSaved={onSaved}
            >
              <CreateTripContent />
            </CreateTripProvider>
          </Box>
        </DialogContent>
      </Dialog>
  )
}

export default CreateTripDialog
